import React from 'react';
import MyImage from '../../Images/website_img.jpg';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import Tilt from 'react-vanilla-tilt';
import './AboutMe.css';
import { Button } from '@material-ui/core';

const AboutMe = ({ user, SetOpen }) => {
      
    // const DownloadFile = () => {
    //     return <a href="https://drive.google.com/uc?export=download&id=17PmbwZka3KdEQw-114b0BGzGSUm0i81r">Some</a>
    // }

    return (
        <section className='about' id='about'>
            <h1 className='title' data-aos="zoom-in">About Me</h1>
            <div className="container">
                <div className="row">
                    <div className="col-lg-5 col-md-12">
                        <div>
                            <Tilt className='p-0 about_img_aria' options={{ scale: 1, max: 25 }}><img src={MyImage} alt="" /></Tilt>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12">
                        <div className='about_info_aria'>
                            <h1 className='text-2xl mb-3'>Md. Tajuuddin Tarek</h1>
                            <p className='font-thin'>Tajuuddin is a <Tooltip TransitionComponent={Zoom} title="MERN - Mongodb Express React Nodejs" placement="top" arrow><span className='highlight'>MERN</span></Tooltip> Stack Developer. He has been involved in web development for almost a long time. He is currently working as a freelancer. He is a developer skilled in creating all types of web sites including <Tooltip TransitionComponent={Zoom} title="CSR - Client Side Rendering" placement="top" arrow><span className='highlight'>CSR</span></Tooltip>, <Tooltip TransitionComponent={Zoom} title="SSR - Server Side Rendering" placement="top" arrow><span className='highlight'>SSR</span></Tooltip>, Static and Dynamic. He likes to have open discussions with his clients and is a beginner-friendly talker. He also writes about web development on various websites as a blogger. This fancy developer is a <Tooltip TransitionComponent={Zoom} title="CSE - Computer Science and Engineering" placement="top" arrow><span className='highlight'>CSE</span></Tooltip> student studying at Shyamoli Ideal Polytechnic Institute in Chittagong, Bangladesh.</p>
                            {
                                user ?
                                <a href="https://drive.google.com/uc?export=download&id=17PmbwZka3KdEQw-114b0BGzGSUm0i81r"><Button className='mt-3 slider_btn'>Download Resume</Button></a> :
                                <Button onClick={() => SetOpen(true)} className='mt-3 slider_btn'>Download Resume</Button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutMe;